import { useCallback, useMemo } from 'react'
import { useState, useEffect, useRef } from 'react'
import {
    View,
    Text,
    TouchableOpacity,
    Image,
    ActivityIndicator,
    Share,
    Platform,
    Animated,
} from 'react-native'
import theme from '../../../theme'
import StyledText from '../../../StyledText'
import parseThousands from '../customUtils/parseThousands/parseThousands'
import { getAuthToken } from '../../utils/functions.utils'
import {
    Ionicons,
    Feather,
    FontAwesome,
} from '@expo/vector-icons'
import { apiUrl } from '../../config/config'
import {
    update_like_local_posts,
    get_post_by_id,
    update_favourite_local_posts,
} from '../../db/posts/index'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { FlatList } from 'react-native-gesture-handler'
import { openDB } from '../../db/indexDB'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import { getAvatarFromCache, setAvatarInCache } from '../../utils/ttlCache'
import styles from './InteractionsPostsStyles'
import { avatarPlaceholder } from '../customUtils/Constants'
import { TrackingServices } from '../../../database/tracking.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { usePostContext } from './context/posts.context'
import { getConection } from '../appBar/context/HeaderContext'
import { getAlert } from '../appBar/context/AlertsContext'
import Constants from 'expo-constants'
import { removeCacheByFragment } from '../../utils/FetchServices'
import { PostTagsTheme } from '../../../themeConstants'
import { debug, info, warn, error, lazy } from '../../utils/logger'
import {
    enqueue,
    createAction,
    subscribeFlushOnReconnect,
} from '../../services/offline/offlineQueue'
import { getReactionAsset } from './utils/reactionAssets'
import { useInteractionsStore } from '../../redux/zustand/interactionsPostStore'

const expoConfig = Constants.expoConfig || { slug: '' }
const __avatarCache = new Map()
const fontScale = 1
const apiEndpointReactions = `${apiUrl}/get_reactions_wall`
const apiEndpoint = `${apiUrl}/add_like_wall`
const addFavourite = `${apiUrl}/add_favourite`

const UserReactionItem = ({ userReaction }) => {
    const [avatar, setAvatarUrl] = useState(null)

    useEffect(() => {
        let mounted = true
        const key = userReaction?.avatar
        const hit = key ? __avatarCache.get(key) : null
        if (hit) {
            const hitStr =
                typeof hit === 'string'
                    ? hit
                    : hit && typeof hit.toString === 'function'
                      ? hit.toString()
                      : null
            if (hitStr) setAvatarUrl(hitStr)
            return
        }
        if (key) {
            // 1) Intentar cache persistente con TTL
            getAvatarFromCache(key)
                .then((cached) => {
                    if (!mounted) return
                    if (cached) {
                        const cachedStr =
                            typeof cached === 'string'
                                ? cached
                                : cached && typeof cached.toString === 'function'
                                  ? cached.toString()
                                  : null
                        if (cachedStr) {
                            __avatarCache.set(key, cachedStr)
                            setAvatarUrl(cachedStr)
                            return true
                        }
                        return true
                    }
                    return false
                })
                .then((servedFromCache) => {
                    if (servedFromCache) return
                    // 2) Resolver desde Storage si no hubo hit
                    getImageStogeUrl(key)
                        .then(async (url) => {
                            if (!mounted) return
                            if (url) {
                                const urlStr =
                                    typeof url === 'string'
                                        ? url
                                        : url && typeof url.toString === 'function'
                                          ? url.toString()
                                          : null
                                if (!urlStr) return
                                __avatarCache.set(key, urlStr)
                                setAvatarUrl(urlStr)
                                // guardar persistente con TTL (24h por defecto)
                                try {
                                    await setAvatarInCache(key, urlStr)
                                } catch {}
                            }
                        })
                        .catch(() => {})
                })
                .catch(() => {})
        }
        return () => {
            mounted = false
        }
    }, [userReaction])
    return (
        <View style={styles.container}>
            <View style={styles.cantainerDataUser}>
                {(() => {
                    let src
                    if (typeof avatar === 'number') {
                        src = avatar
                    } else if (
                        avatar &&
                        typeof avatar === 'object' &&
                        typeof avatar.toString === 'function'
                    ) {
                        // Puede venir como instancia URL u objeto con toString(); forzamos a string
                        src = { uri: avatar.toString() || avatarPlaceholder }
                    } else if (typeof avatar === 'string') {
                        src = { uri: avatar || avatarPlaceholder }
                    } else {
                        src = { uri: avatarPlaceholder }
                    }
                    return <Image source={src} style={styles.avatar} />
                })()}
                <Text style={styles.userName}>
                    {userReaction?.user_name?.capitalizeWords()}
                </Text>
            </View>

            {userReaction && userReaction.reaction_index !== 0 ? (
                <Image
                    source={getReactionAsset(userReaction.reaction_name)}
                    style={styles.reactionIcon}
                />
            ) : (
                <Image
                    source={require('../../../assets/reactions/heart.png')}
                    size={26}
                    style={styles.reactionIcon}
                />
            )}
        </View>
    )
}

export const ReactionItem = ({ reaction, onClickReaction }) => {

    return (
        <View>
            <TouchableOpacity
                style={styles.containerReactionItem}
                onPress={() => onClickReaction(reaction)}
            >
                {reaction && reaction.index !== 0 ? (
                    <Image
                        source={getReactionAsset(reaction?.name)}
                        style={
                            reaction.isSelected
                                ? styles.reactionSelected
                                : styles.reactionUnselected
                        }
                    />
                ) : (
                    <Image
                        source={require('../../../assets/reactions/heart.png')}
                        style={
                            reaction.isSelected
                                ? styles.reactionSelected
                                : styles.reactionUnselected
                        }
                    />
                )}

                <Text
                    style={
                        reaction.isSelected
                            ? styles.reactionCountSelected
                            : styles.reactionCountUnselected
                    }
                >
                    {reaction.count}
                </Text>
            </TouchableOpacity>
        </View>
    )
}

export const ReactionsModal = ({
    reactions: initialReactions,
    handleLikeClick,
    latest_reactions,
}) => {
    const [reactions, setReactions] = useState(initialReactions)

    const onClickReaction = async (reaction) => {
        // Optimista local inmediato en el modal
        try {
            setReactions((prev) => {
                if (!Array.isArray(prev)) return prev
                const rid =
                    reaction?._id?.toString?.() ||
                    reaction?.reaction_id?.toString?.()
                // ¿El usuario tocó la misma reacción que ya tenía? → toggle off
                const isToggleOff = prev.some(
                    (r) =>
                        (r._id?.toString?.() === rid ||
                            r.reaction_id?.toString?.() === rid) &&
                        r.isSelected,
                )
                return prev.map((r) => {
                    const rId = r?._id?.toString?.() || r?.reaction_id?.toString?.()
                    if (rId === rid) {
                        if (isToggleOff) {
                            // Toggle off: deseleccionar y decrementar
                            return {
                                ...r,
                                isSelected: false,
                                count: Math.max((Number(r.count) || 0) - 1, 0),
                            }
                        }
                        // Nueva selección: seleccionar e incrementar
                        return {
                            ...r,
                            isSelected: true,
                            count: (Number(r.count) || 0) + 1,
                        }
                    }
                    // Si otra reacción estaba seleccionada y estamos cambiando (no toggle off),
                    // deseleccionarla y decrementar
                    if (r.isSelected && !isToggleOff) {
                        return {
                            ...r,
                            isSelected: false,
                            count: Math.max((Number(r.count) || 0) - 1, 0),
                        }
                    }
                    return r
                })
            })
        } catch {
            console.error('ReactionsModal', 'Error updating reactions state optimistically')
        }

        // Llamada real - actualiza store + dispara API call.
        // NO sobreescribir el estado local del modal con el retorno del store,
        // porque el store puede tener reactions incompletas (sin name/index)
        // y con menos items que el catálogo completo.
        // El optimistic update local de arriba ya maneja la UI correctamente.
        handleLikeClick(reaction._id)
    }

    const { languageFile } = getLanguage()

    return (
        <View style={styles.containerReactionsModal}>
            <FlatList
                data={reactions}
                keyExtractor={(item) => item._id}
                horizontal={true}
                nestedScrollEnabled={true}
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={styles.contentContainerStyle}
                renderItem={({ item }) => (
                    <ReactionItem
                        reaction={item}
                        onClickReaction={onClickReaction}
                    />
                )}
            />

            {latest_reactions && latest_reactions?.length > 0 ? (
                <>
                    <Text style={styles.subtitleSection}>
                        {languageFile.reactions_from_other_users}
                    </Text>

                    <FlatList
                        data={latest_reactions}
                        keyExtractor={(item) => item._id}
                        horizontal={false}
                        nestedScrollEnabled={true}
                        showsVerticalScrollIndicator={false}
                        showsHorizontalScrollIndicator={false}
                        renderItem={({ item }) => (
                            <UserReactionItem userReaction={item} />
                        )}
                    />

                    <View style={styles.spacer1}></View>
                    <View style={styles.spacer1}></View>
                </>
            ) : (
                <>
                    <View style={styles.messageContainer}>
                        <Image
                            style={styles.imageAsset}
                            source={require('../../../assets/noReactions.png')}
                        />
                        <Text style={styles.titleText}>
                            {languageFile.no_reactions}
                        </Text>
                        <Text style={styles.descriptionText}>
                            {languageFile.leave_your_reaction}
                        </Text>
                    </View>
                </>
            )}
        </View>
    )
}

const InteractionsPosts = ({
    posts,
    onCommentClick,
    comments_counter: propCommentsCounter,
    reactions,
    favourite,
    interactions,
    isGoTo,
    updateInteractions,
    onReactionPickerRef,
    showReactionPicker,
    setShowReactionPicker,
}) => {
    const { updateFavouritePostsContext, reloadFavourite, postsContext } = usePostContext()

    const { openBottomSheet } = useBottomSheet()
    const { languageFile } = getLanguage()
    const [isFavourite, setIsFavourite] = useState(favourite)
    const [latestReactions, setLatestReactions] = useState([])

    // Store selectors
    const toggleReaction = useInteractionsStore((s) => s.toggleReaction)
    const interactionFromStore = useInteractionsStore(
        useCallback((state) => state.interactions[String(posts?._id)], [posts?._id]),
    )

    const comments_counter =
        interactionFromStore?.comments_counter ||
        interactionFromStore?.comment_count ||
        propCommentsCounter ||
        0

    const effectiveInteractions = interactionFromStore || posts.reactions_total || interactions

    // 2a. Derivar all_reactions directamente (sin useState)
    const all_reactions = effectiveInteractions?.reactions || []

    // 2b. Derivar optionSelected con useMemo desde user_reaction + catálogo
    const optionSelected = useMemo(() => {
        const ur = effectiveInteractions?.user_reaction?.[0]
        if (ur && Array.isArray(reactions) && reactions.length) {
            // Prioridad 1: match exacto por _id (más confiable)
            const matchById = reactions.find(
                (r) => r._id?.toString?.() === ur.reaction_id?.toString?.(),
            )
            if (matchById) {
                return {
                    ...matchById,
                    reaction_id: ur.reaction_id || matchById._id,
                    isSelected: true,
                }
            }
            // Prioridad 2: fallback por index o name (puede ser inexacto si el store
            // no tenía el name correcto, pero cubre edge cases)
            const matchByMeta = reactions.find(
                (r) => r.index === ur.reaction_index || r.name === ur.name,
            )
            if (matchByMeta) {
                return {
                    ...matchByMeta,
                    reaction_id: ur.reaction_id || matchByMeta._id,
                    isSelected: true,
                }
            }
            // Fallback: devolver datos del user_reaction directamente
            return {
                reaction_id: ur.reaction_id,
                _id: ur._id || ur.reaction_id,
                name: ur.name || ur.reaction_name || 'like',
                index: ur.reaction_index ?? 0,
                isSelected: true,
            }
        }
        // Sin user_reaction → estado neutro
        return null
    }, [effectiveInteractions?.user_reaction, reactions])

    // countReactions derivado solo de all_reactions (una sola fuente de verdad)
    const countReactions = useMemo(() => {
        if (Array.isArray(all_reactions) && all_reactions.length) {
            return all_reactions.reduce((sum, r) => sum + (Number(r?.count) || 0), 0)
        }
        return 0
    }, [all_reactions])

    const { isConnected, hasInternet, connectedStable } = getConection()

    // Ref de conectividad actualizado en cada render para usarlo dentro de closures/debounce
    const connectedRef = useRef(isConnected && hasInternet)
    useEffect(() => {
        connectedRef.current = isConnected && hasInternet
    }, [isConnected, hasInternet])

    // Estados para long press (compartidos entre media y botón de reacciones)
    const [isLongPressingButton, setIsLongPressingButton] = useState(false)
    const longPressTimerButtonRef = useRef(null)
    const progressAnimButton = useRef(new Animated.Value(0)).current

    const { setAlert } = getAlert()

    // Suscribir flush offline una vez montado (RN)
    useEffect(() => {
        subscribeFlushOnReconnect()
    }, [])

    // Sincronizar favourites desde postsContext
    useEffect(() => {
        const indexForm = postsContext.findIndex(
            (postContext) => postContext._id === posts._id,
        )
        if (indexForm !== -1) {
            setIsFavourite(postsContext[indexForm].status_favourite ?? favourite)
        }
    }, [reloadFavourite])

    // fetchReactions simplificado (solo para el modal)
    const fetchReactions = async () => {
        try {
            if (!posts?._id) return { count_reactions: [], latest_reactions: [] }

            if (connectedStable) {
                const authToken = await getAuthToken()
                if (!authToken) return { count_reactions: [], latest_reactions: [] }
                const response = await fetch(apiEndpointReactions, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        post_id: posts?._id,
                    },
                })

                if (response.ok) {
                    const data = await response.json()
                    if (
                        data.status === 1 &&
                        data.single &&
                        data.single.count_reactions?.length > 0
                    ) {
                        setLatestReactions(data.single.latest_reactions || [])
                        await update_like_local_posts(
                            posts._id,
                            data.single.count_reactions,
                        )
                        return data.single
                    }
                } else {
                    throw new Error('Fallo al obtener las reacciones')
                }
            } else {
                const database = await openDB()
                const get_post = await get_post_by_id(database, posts._id)
                return {
                    count_reactions: get_post.reaction_counter || [],
                    latest_reactions: [],
                }
            }
            return { count_reactions: [], latest_reactions: [] }
        } catch (err) {
            error('Reactions', 'Error en la solicitud de reacciones:', err)
            return { count_reactions: [], latest_reactions: [] }
        }
    }

    const OpenReactions = async () => {
        if (!isConnected && !hasInternet) {
            setAlert(
                'No puedes realizar esta acción sin conexión a internet',
                'white',
                'wifi-off',
                'rgba(0, 0, 0, 0.8)',
            )
            return
        }
        try {
            const fetch_reactions = await fetchReactions()
            const counts = Array.isArray(fetch_reactions?.count_reactions)
                ? fetch_reactions.count_reactions
                : []
            // Catálogo autorizado desde props
            const defs = Array.isArray(reactions) ? reactions : []
            // user_reaction para marcar selección
            const ur = effectiveInteractions?.user_reaction?.[0]
            const urId = ur?.reaction_id?.toString?.()
            const merged = defs.map((def) => {
                const found = counts.find(
                    (c) =>
                        (c?.reaction_id || c?._id)?.toString?.() ===
                        def?._id?.toString?.(),
                )
                const isSel = urId && def?._id?.toString?.() === urId
                return {
                    ...def,
                    count: Number(found?.count) || 0,
                    isSelected: !!isSel,
                }
            })
            
            openBottomSheet(
                <ReactionsModal
                    reactions={merged}
                    handleLikeClick={handleLikeClick}
                    latest_reactions={
                        fetch_reactions?.latest_reactions || latestReactions
                    }
                />,
                ['60%'],
            )
        } catch (err) {
            error('Reactions', 'OpenReactions error', err)
        }
    }

    // Debounce ref para API calls (último click gana)
    const debounceRef = useRef({ timer: null, originalPrevious: null, latestReactionId: null, clickCount: 0 })
    const suppressOnPressRef = useRef(false)

    // 2e. handleLikeClick reescrito: toggle síncrono + API debounced
    const handleLikeClick = (reaction_id) => {
        if (!isConnected || !hasInternet) {
            setAlert(
                'No puedes realizar esta acción sin conexión a internet',
                'white',
                'wifi-off',
                'rgba(0, 0, 0, 0.8)',
            )
            return
        }

        const postId = String(posts?._id)

        // 1. Toggle store inmediatamente (síncrono, UI se actualiza al instante)
        const { previous, current } = toggleReaction(postId, reaction_id, reactions)

        // 2. Notificar al padre
        try { updateInteractions?.(current) } catch {}

        // 3. API call con debounce de 300ms (último click gana)
        const d = debounceRef.current
        if (!d.timer) {
            // Primer click del burst: guardar estado original para rollback
            d.originalPrevious = previous
            d.clickCount = 0
        }
        d.latestReactionId = reaction_id
        d.clickCount++

        clearTimeout(d.timer)
        d.timer = setTimeout(async () => {
            d.timer = null
            const totalClicks = d.clickCount
            d.clickCount = 0

            // Verificar conectividad en el momento exacto del dispatch (no al hacer click)
            if (!connectedRef.current) {
                // Sin red: mantener estado optimista y encolar para retry al reconectar
                try {
                    await enqueue(createAction('reaction', postId, { reaction_id: d.latestReactionId }))
                } catch {}
                for (let i = 0; i < totalClicks; i++) {
                    useInteractionsStore.getState().decrementOptimisticVersion(postId)
                }
                return
            }

            try {
                const authToken = await getAuthToken()
                if (!authToken) throw new Error('No auth token')

                const headers = {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                    post_id: postId,
                }
                if (d.latestReactionId) {
                    headers.reaction_id = d.latestReactionId
                }

                const response = await fetch(apiEndpoint, {
                    method: 'POST',
                    headers,
                })

                if (!response.ok) throw new Error('Fallo al procesar la reacción')
                const data = await response.json()

                TrackingServices.addTracking(
                    data.single?.reaction_id,
                    'add_like_wall',
                    'posts',
                )

                // Éxito: solo actualizar DB local + invalidar cache. NO sobreescribir store/UI.
                const currentReactions =
                    useInteractionsStore.getState().interactions[postId]?.reactions || []
                await update_like_local_posts(posts._id, currentReactions)
                removeCacheByFragment('get_reactions_wall_according_id')
            } catch (err) {
                console.error('Reactions', 'handleLikeClick API error', err)
                // TypeError: Network request failed → error de red transitorio (ej. app volviendo de background)
                // Mantener estado optimista + encolar para retry. NO hacer rollback ni mostrar modal.
                const isNetworkError =
                    err instanceof TypeError && err.message === 'Network request failed'
                if (isNetworkError) {
                    // ✅ [FIXED] Antes acá daba error modal + rollback del corazón. Ahora se mantiene optimista y se encola.
                    console.warn('[InteractionsPosts] Network error transitorio detectado — antes mostraba modal y despintaba corazón, ahora se encola para retry:', err.message)
                    try {
                        await enqueue(createAction('reaction', postId, { reaction_id: d.latestReactionId }))
                    } catch {}
                } else {
                    // Error de servidor: rollback + modal
                    if (d.originalPrevious) {
                        useInteractionsStore.getState().setInteractions({
                            [postId]: d.originalPrevious,
                        })
                        try { updateInteractions?.(d.originalPrevious) } catch {}
                    }
                    setAlert(
                        'Ocurrió un error inesperado. Intenta nuevamente.',
                        'white',
                        'alert-circle',
                        'rgba(0, 0, 0, 0.8)',
                    )
                }
            } finally {
                // Decrementar todas las versiones optimistas de este burst
                for (let i = 0; i < totalClicks; i++) {
                    useInteractionsStore.getState().decrementOptimisticVersion(postId)
                }
            }
        }, 300)

        // Retornar reactions actualizadas sincrónicamente (para el modal)
        return current.reactions
    }

    // Exponer handleLikeClick a través de la ref para el selector de reacciones en web
    useEffect(() => {
        if (onReactionPickerRef) {
            onReactionPickerRef.current = handleLikeClick
        }
    }, [handleLikeClick, onReactionPickerRef])

    const saveFavorite = async (postID) => {
        try {
            if (connectedStable) {
                TrackingServices.addTracking(
                    postID,
                    'add_favourite',
                    'post_favourites',
                )
                const authToken = await getAuthToken()
                if (!authToken) return
                const response = await fetch(addFavourite, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        post_id: postID,
                    },
                })

                if (!response.ok) {
                    throw new Error('Fallo al obtener los favoritos')
                }
                const data = await response.json()

                updateFavouritePostsContext(
                    posts._id,
                    data['single']['status_favourite'],
                )

                setIsFavourite(data['single']['status_favourite'])

                const res = await update_favourite_local_posts(
                    posts._id,
                    data['single']['status_favourite'],
                )
            } else {
                // Offline: toggle local y encolar
                const next = isFavourite === 1 ? 0 : 1
                setIsFavourite(next)
                try {
                    updateFavouritePostsContext(posts._id, next)
                } catch {}
                try {
                    await update_favourite_local_posts(posts._id, next)
                } catch {}
                try {
                    await enqueue(
                        createAction('favourite', String(postID), { status: next }),
                    )
                } catch {}
                setAlert(
                    'Favorito guardado offline. Se sincronizará al reconectar.',
                    'white',
                    'wifi-off',
                    'rgba(0, 0, 0, 0.8)',
                )
            }
        } catch (err) {
            error('Interactions', 'Error en la solicitud de like 1:', err)
        }
    }

    async function shareLink(link) {
        try {
            let message =
                Platform.OS != 'android'
                    ? 'Comparte este enlace\n'
                    : `Comparte este enlace\n${link}`
            let url = link
            const result = await Share.share({
                message: message,
                url: url, // en iOS podés usar también esta propiedad
                title: posts.title,
            })

            if (result.action === Share.sharedAction) {
                if (result.activityType) {
                    debug('Share', 'Compartido con actividad', result.activityType)
                } else {
                    info('Share', 'Compartido')
                }
            } else if (result.action === Share.dismissedAction) {
                debug('Share', 'Cancelado')
            }
        } catch (err) {
            error('Share', 'Error al compartir', err?.message)
        }
    }

    // Manejador de clic del botón
    const doHandleButtonAction = useCallback(() => {
        if (!isConnected || !hasInternet) {
            setAlert(
                'No puedes realizar esta acción sin conexión a internet',
                'white',
                'wifi-off',
                'rgba(0, 0, 0, 0.8)',
            )
            return
        }
        if (showReactionPicker) {
            return
        }

        const isLikeReaction = (name) => name === 'like' || name === 'likee' || name === 'heart'

        // Fallback
        const reactionsCatalog =
            Array.isArray(reactions) && reactions.length > 0
                ? reactions
                : Array.isArray(all_reactions) && all_reactions.length > 0
                    ? all_reactions
                    : []

        const hasLike =
            optionSelected?.isSelected && isLikeReaction(optionSelected?.name)
        const hasOtherReaction =
            optionSelected?.isSelected && !isLikeReaction(optionSelected?.name)

        if (hasLike) {
            handleLikeClick(optionSelected.reaction_id)
        } else if (hasOtherReaction) {
            const likeReaction = reactionsCatalog?.find((r) => isLikeReaction(r.name))
            if (!likeReaction) {
                error('Reactions', 'Like reaction not found!')
                return
            }
            handleLikeClick(likeReaction._id || likeReaction.reaction_id)
        } else {
            const likeReaction = reactionsCatalog?.find((r) => isLikeReaction(r.name))
            if (!likeReaction) {
                error(
                    'Reactions',
                    'Like/Heart reaction not found!',
                    reactionsCatalog?.map((r) => r.name),
                )
                return
            }
            handleLikeClick(likeReaction._id || likeReaction.reaction_id)
        }
    }, [
        showReactionPicker,
        optionSelected,
        reactions,
        all_reactions,
        handleLikeClick,
        isConnected,
        hasInternet,
    ])

    const handleButtonClick = useCallback(
        (e) => {
            // Si se estableció supresión (ej. ya se ejecutó por mouse up o long press), limpiar y no ejecutar
            if (suppressOnPressRef.current) {
                suppressOnPressRef.current = false
                return
            }
            doHandleButtonAction()
        },
        [doHandleButtonAction],
    )

    const RenderButtonLike = useCallback(() => {
        // Asegurar que siempre hay un valor válido
        const currentOption = optionSelected || {
            name: 'like',
            isSelected: false,
            reaction_id: '',
        }
        // 2f. Siempre usar dato del store
        const reactionCount = countReactions

        const progressBarWidth = progressAnimButton.interpolate({
            inputRange: [0, 1],
            outputRange: ['0%', '100%'],
        })

        // Ref para saber cuándo empezó el mouse down
        const mouseDownTimeRef = useRef(null)

        // Handlers para mouse events (web only)
        const handleMouseDown = (e) => {
            if (Platform.OS !== 'web') return

            mouseDownTimeRef.current = Date.now()

            // DELAY de 200ms antes de iniciar la animación de long press
            longPressTimerButtonRef.current = setTimeout(() => {
                setIsLongPressingButton(true)

                Animated.timing(progressAnimButton, {
                    toValue: 1,
                    duration: 800,
                    useNativeDriver: false,
                }).start()

                // Timer para abrir el picker después de 1000ms total
                longPressTimerButtonRef.current = setTimeout(() => {
                    setShowReactionPicker(true)
                    setIsLongPressingButton(false)
                    progressAnimButton.setValue(0)
                }, 800)
            }, 200)
        }

        const handleMouseUp = (e) => {
            if (Platform.OS !== 'web') return

            const pressDuration = Date.now() - (mouseDownTimeRef.current || 0)

            progressAnimButton.setValue(0)

            // Limpiar todos los timers
            if (longPressTimerButtonRef.current) {
                clearTimeout(longPressTimerButtonRef.current)
                longPressTimerButtonRef.current = null
            }

            // Si fue un clic corto (< 500ms) y NO se abrió el picker, ejecutar handleButtonClick
            const wasShortClick = pressDuration < 500 && !showReactionPicker

            setIsLongPressingButton(false)
            mouseDownTimeRef.current = null

            if (wasShortClick) {
                // Ejecutar acción ya desde mouseUp y suprimir el onPress posterior
                suppressOnPressRef.current = true
                doHandleButtonAction()
            }
        }

        const handleMouseLeave = (e) => {
            if (Platform.OS !== 'web') return

            progressAnimButton.setValue(0)
            setIsLongPressingButton(false)

            if (longPressTimerButtonRef.current) {
                clearTimeout(longPressTimerButtonRef.current)
                longPressTimerButtonRef.current = null
            }

            mouseDownTimeRef.current = null
        }

        // Bounce en el contador ante cambios de reacción
        const bounceScale = useRef(new Animated.Value(1)).current
        useEffect(() => {
            try {
                Animated.sequence([
                    Animated.spring(bounceScale, {
                        toValue: 1.15,
                        friction: 5,
                        tension: 140,
                        useNativeDriver: true,
                    }),
                    Animated.spring(bounceScale, {
                        toValue: 1,
                        friction: 5,
                        tension: 140,
                        useNativeDriver: true,
                    }),
                ]).start()
            } catch {}
        }, [reactionCount])

        // Componente memoizado para el icono de reacción
        const ReactionIcon = useMemo(() => {
            if (!currentOption) {
                return (
                    <ActivityIndicator color={theme.colors.colorPrimary} size={24} />
                )
            }

            // Tratar 'heart' como una variante de like
            const isLikeReaction = (name) =>
                name === 'like' || name === 'likee' || name === 'heart'
            const displayName = currentOption?.name || currentOption?.reaction_name
            const isLike = isLikeReaction(displayName)

            // Mostrar imagen de reacción sólo si NO es un like/heart y hay un nombre válido
            if (displayName && !isLike) {
                const reactionImage = getReactionAsset(displayName)
                return (
                    <Image
                        source={reactionImage}
                        style={
                            currentOption.isSelected
                                ? styles.optionSelected
                                : styles.optionUnselected
                        }
                        onError={() =>
                            error(
                                'Reactions',
                                'ReactionIcon failed to load',
                                displayName,
                            )
                        }
                    />
                )
            }

            // Si es un like/heart seleccionado, corazón relleno
            if (currentOption.isSelected) {
                return (
                    <Ionicons
                        name='heart'
                        size={25}
                        color={theme.colors.colorHeart}
                        style={styles.iconReactionPosts}
                    />
                )
            }

            // Si NO hay ninguna reacción aún en el post y el usuario no reaccionó, NO mostrar corazón por defecto
            // Mostrar un ícono neutro
            if (
                !currentOption.isSelected &&
                (reactionCount === 0 || !reactionCount)
            ) {
                return (
                    <Ionicons
                        name='happy-outline'
                        size={25}
                        color={'#9E9E9E'}
                        style={styles.iconReactionPosts}
                    />
                )
            }

            // Caso por defecto: corazón outline (hay reacciones en el post pero el usuario no reaccionó)
            return (
                <Ionicons
                    name='heart-outline'
                    size={25}
                    color={theme.colors.colorHeart}
                    style={styles.iconReactionPosts}
                />
            )
        }, [
            currentOption?.name,
            currentOption?.reaction_name,
            currentOption?.isSelected,
            currentOption?.reaction_id,
            reactionCount,
        ])
        const reacti = reactionCount
        return (
            <View style={{ position: 'relative' }}>
                <TouchableOpacity
                    style={styles.reactionSector}
                    onPress={handleButtonClick}
                    onLongPress={
                        Platform.OS !== 'web'
                            ? () => {
                                  suppressOnPressRef.current = true
                                  OpenReactions()
                              }
                            : undefined
                    }
                    onMouseDown={Platform.OS === 'web' ? handleMouseDown : undefined}
                    onMouseUp={Platform.OS === 'web' ? handleMouseUp : undefined}
                    onMouseLeave={
                        Platform.OS === 'web' ? handleMouseLeave : undefined
                    }
                >
                    {/* Mostrar siempre el icono para que el asset cambie de inmediato */}
                    {ReactionIcon}

                    <Animated.View
                        style={[
                            styles.footerPostTexts,
                            { transform: [{ scale: bounceScale }] },
                        ]}
                    >
                        <StyledText fontSize='smallText' fontWeight='bold'>
                            {parseThousands(reacti) + ' '}
                            {reactionCount === 1 && fontScale > 1
                                ? 'Reacc...'
                                : reactionCount === 1
                                  ? languageFile.reaction || 'Reacción'
                                  : fontScale > 1
                                    ? 'Reacc...'
                                    : languageFile.reactions || 'Reacciones'}
                        </StyledText>
                    </Animated.View>
                </TouchableOpacity>

                {/* Overlay de progreso durante long press */}
                {isLongPressingButton && (
                    <View
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: 8,
                            pointerEvents: 'none',
                        }}
                    >
                        <View
                            style={{
                                width: '90%',
                                height: 4,
                                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                borderRadius: 2,
                                overflow: 'hidden',
                            }}
                        >
                            <Animated.View
                                style={{
                                    height: '100%',
                                    backgroundColor: theme.colors.colorPrimary,
                                    width: progressBarWidth,
                                }}
                            />
                        </View>
                    </View>
                )}
            </View>
        )
    }, [
        optionSelected,
        countReactions,
        languageFile,
        fontScale,
        isLongPressingButton,
        showReactionPicker,
        progressAnimButton,
        reactions,
        isConnected,
        hasInternet,
    ])

    return (
        <>
            <View style={[styles.interactionsLine, { marginTop: isGoTo ? 16 : 0 }]}>
                <View style={styles.footerPost}>
                    {expoConfig.slug != 'lesaffre-one' && (
                        <>
                            {/* Botón Me gusta */}
                            <RenderButtonLike />
                            {/* Botón Comentarios */}
                            {expoConfig.slug != 'one-pfizer' && (
                                <TouchableOpacity
                                    style={styles.reactionSector}
                                    onPress={(e) => {
                                        if (e && e.preventDefault) e.preventDefault()
                                        if (e && e.stopPropagation)
                                            e.stopPropagation()
                                        onCommentClick(e)
                                    }}
                                >
                                    <Feather
                                        name='message-square'
                                        size={24}
                                        color={theme.colors.colorComment}
                                        style={styles.iconReactionPosts}
                                    />

                                    <View style={styles.footerPostTexts}>
                                        <StyledText
                                            fontSize='smallText'
                                            fontWeight='bold'
                                        >
                                            {parseThousands(comments_counter)}
                                            {comments_counter &&
                                            comments_counter == 1 &&
                                            fontScale > 1
                                                ? ' Coment...'
                                                : comments_counter &&
                                                    comments_counter == 1
                                                  ? ' Comentario'
                                                  : fontScale > 1
                                                    ? ' Coment...'
                                                    : ' Comentarios'}
                                        </StyledText>
                                    </View>
                                </TouchableOpacity>
                            )}
                        </>
                    )}
                    {/* Botón Compartir */}
                    {posts.link_share && posts.link_share !== '' && (
                        <TouchableOpacity
                            style={styles.reactionSector}
                            onPress={() => shareLink(posts.link_share)}
                        >
                            <Feather
                                name='send'
                                size={25}
                                color={theme.colors.colorShare}
                                style={styles.iconReactionPosts}
                            />
                        </TouchableOpacity>
                    )}
                </View>
                <View style={styles.interactionRight}>
                    <TouchableOpacity
                        style={styles.footerPost}
                        onPress={() => saveFavorite(posts._id)}
                    >
                        <FontAwesome
                            name={isFavourite === 1 ? 'bookmark' : 'bookmark-o'}
                            size={24}
                            color={PostTagsTheme.tagSelectedColor}
                            style={styles.iconReactionPosts}
                        />
                        {/* content-save-settings */}
                    </TouchableOpacity>
                </View>
            </View>
        </>
    )
}

export default InteractionsPosts
